import CityPageTemplate from "../city-template/CityPageTemplate";
import { conroeConfig } from "./data";

export default function ConroePage() {
  return <CityPageTemplate config={conroeConfig} />;
}